/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { Form, Table, ConfigProvider, Space, Tag, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'
import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';





const Bsqrz = () => {


  const [bangm, setbangm] = useState([]);
  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/p_sqrz')
      setbangm(res.rescode)
    }

    getau()

  }, [])

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });





  const columns = [
    // {
    //   title: '订单编号',
    //   dataIndex: 'ddno',
    //   key: 'ddno',
    //   sorter: (a, b) => a.key - b.key,
    //   sortDirections: ['descend', 'ascend'],
    // },
    {
      title: '变动方向',
      dataIndex: 'bgfx',
      key: 'bgfx',
      render: (_, record) => (
        <Space size="middle">
          {record.bgfx === "A" && <Tag color="volcano" >增加</Tag>}
          {record.bgfx === "S" && <Tag color="green" >消耗</Tag>}
        </Space>
      ),

    },
    {
      title: '变动数量',
      dataIndex: 'bgnum',
      key: 'bgnum',

    },
    {
      title: '原数量',
      dataIndex: 'ynum',
      key: 'ynum',
    },
    {
      title: '现数量',
      dataIndex: 'xnum',
      key: 'xnum',
    },
    {
      title: '任务名称',
      dataIndex: 'dw',
      key: 'dw',
    },
    {
      title: '时间',
      dataIndex: 'd_time',
      key: 'd_time',
      ...getColumnSearchProps('d_time'),

    }
  ];














  const [form] = Form.useForm();
  return (<ConfigProvider locale={zhCN} >

    <div
    // style={containerStyle} 
    >

      <Form form={form} component={false}>

        <Table size="small" columns={columns} dataSource={bangm} rowKey="ddno" />

      </Form>



    </div>


  </ConfigProvider>

  );
};
export default Bsqrz;